/**
 * Deutsche Bezeichnungen für die Zustände und Einstufungen der Dienste.
 *
 * Die Dienste antworten mit den Werten ihrer Enums — `review_lead`,
 * `not_applicable`, `partially_effective`. Wo die Oberfläche einen solchen Wert
 * unverändert anzeigt, steht dort englischer Bezeichner-Text mitten in einer
 * deutschen Anwendung. Das ist mehr als unschön: `review_lead` sagt einem
 * Anwender nicht, dass der Bericht bei der Prüfungsleitung liegt.
 *
 * Die Zuordnung stand bisher nur in StatusChip und war deshalb nur dort
 * nutzbar — Diagramme, Kacheln und Auswahlfelder zeigten den Rohwert.
 */
export const ZUSTAND_LABEL: Record<string, string> = {
  // Engagement
  planning: 'Planung',
  fieldwork: 'Feldarbeit',
  reporting: 'Berichterstattung',
  review: 'In Prüfung',
  review_lead: 'Prüfung durch Prüfungsleitung',
  review_director: 'Prüfung durch Revisionsleitung',
  // Wie Stepper und Verlauf des Auftrags (Testgrundlage 2.2, T45: „Endfassung“ neben „Abschluss“).
  final: 'Abschluss',
  closed: 'Geschlossen',
  // Common
  planned: 'Geplant',
  in_review: 'In Prüfung',
  draft: 'Entwurf',
  open: 'Offen',
  cancelled: 'Abgesagt',
  submitted: 'Eingereicht',
  in_progress: 'In Bearbeitung',
  completed: 'Abgeschlossen',
  reviewed: 'Geprüft',
  approved: 'Genehmigt',
  distributed: 'Verteilt',
  correction: 'Korrektur',
  // Finding
  confirmed: 'Bestätigt',
  disputed: 'Umstritten',
  resolved: 'Gelöst',
  // Measure
  implemented: 'Umgesetzt',
  verified: 'Verifiziert',
  risk_accepted: 'Restrisiko akzeptiert',
  rejected: 'Abgelehnt',
  overdue: 'Überfällig',
  escalated: 'Eskaliert',
  // General
  active: 'Aktiv',
  inactive: 'Inaktiv',
  archived: 'Archiviert',
  sealed: 'Versiegelt',
  pending: 'Ausstehend',
  flagged: 'Markiert',
  accepted: 'Akzeptiert',
  // Severity
  none: 'Kein Mangel',
  notable: 'Bemerkenswert',
  material: 'Wesentlich',
  serious: 'Schwerwiegend',
  critical: 'Kritisch',
  // Risk
  low: 'Niedrig',
  medium: 'Mittel',
  high: 'Hoch',
  // Question / Action
  answered: 'Beantwortet',
  not_applicable: 'Nicht anwendbar',
  // Report types
  single_audit: 'Einzelprüfung',
  annual: 'Jahresbericht',
  ad_hoc: 'Ad-hoc-Bericht',
  special: 'Sonderbericht',
  // Engagement types
  assurance: 'Prüfung',
  consulting: 'Beratung',
  followup: 'Nachschau',
};

/**
 * Die Bezeichnung zu einem Wert, oder eine lesbare Fassung davon.
 *
 * Ein unbekannter Wert wird nicht verschluckt: er erscheint mit Leerzeichen
 * statt Unterstrichen und großem Anfangsbuchstaben. Ein fehlender Eintrag soll
 * auffallen, aber nichts kaputtmachen.
 */
export function zustandLabel(wert: string | null | undefined): string {
  if (!wert) return '–';
  const treffer = ZUSTAND_LABEL[wert];
  if (treffer) return treffer;
  return wert.replace(/_/g, ' ').replace(/^./, (z) => z.toUpperCase());
}
